import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './tickethistory.css';
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";
import bwipjs from 'bwip-js'; 
import { API_URL } from './environment';

import { useAuth } from '../context/AuthContext'; // ✅ Import useAuth correctly
import { permissions } from "./permissions"; // ✅ Import permissions

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import betmap from './betmap.json';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import * as XLSX from 'xlsx';

// import iconOk from './../images/ok-btn.svg';
// import iconClose from './../images/icon-close.svg';
// import iconReplay from './../images/icon-home.svg';
// import iconReceipt from './../images/receipt.svg';
// import iconReprint from './../images/reprint.svg';
// import iconRepeatBet from './../images/icon-repeat-bet.svg';

import homeIcon from '../images/icons/home-icon.svg';
import createIcon from '../images/icons/create-icon.svg';
import validateIcon from '../images/icons/validate-icon.svg';
import historyIcon from '../images/icons/history-icon.svg';
import shiftIcon from '../images/reprint.svg';



function Tickethistory() {
  const navigate = useNavigate();
  const { user, login, logout } = useAuth(); // ✅ Now user, login, and logout are accessible
  const storedUser = JSON.parse(localStorage.getItem("sun_user") || "null");
  const isCashier = storedUser && storedUser.role === 'CASHIER';

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const isFirstLoadRef = useRef(true);

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);

  // Now store startDate/endDate at the top level
  const [dateRangeData, setDateRangeData] = useState({
    startDate: '',
    endDate: '',
  });

  const [activeItemId, setActiveItemId] = useState(null);
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10; // Number of items per page

  const [inputPage, setInputPage] = useState(currentPage);
  const [activeDate, setActiveDate] = useState('');
  const calendarRef = useRef(null);

// 1) Keep these at the component level
// const [startDate, setStartDate] = useState(null);
// const [endDate, setEndDate] = useState(null);
const [selectingEnd, setSelectingEnd] = useState(false);

const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

const [shopsList, setShopsList] = useState([]);
const [selectedShop, setSelectedShop] = useState('');
const selectedShopRef = useRef('');
const [searchNanoId, setSearchNanoId] = useState('');

const getCashierShopId = useCallback(() => {
  const shopId = localStorage.getItem('sun_bettingShopId');
  if (!shopId || shopId === 'undefined' || shopId === '-') {
    return '';
  }
  return shopId;
}, []);

const getShopIdForRefresh = useCallback((shopId = selectedShopRef.current) => {
  if (isCashier) {
    return getCashierShopId();
  }
  return shopId;
}, [getCashierShopId, isCashier]);

useEffect(() => {
  selectedShopRef.current = selectedShop;
}, [selectedShop]);

// handle change betiing shop


const handleInputChange = async (e) => {
    const shopId = e.target.value;
    setSelectedShop(shopId);
    setCurrentPage(1);
    setInputPage(1);
    await refreshTicketsHistory(
      dateRangeData.startDate,
      dateRangeData.endDate,
      1,
      getShopIdForRefresh(shopId)
    );
};

const handleNanoIdSearchChange = (e) => {
  setSearchNanoId(e.target.value || '');
};


// 2) In your date-change handler:
const handleDateChange = async (date) => {
  // If the user is navigating months (returns a string) or typing in something, ignore it:
  if (typeof date === "string") return;

  // Helper function to format dates
  const formatDate = (d, startOfDay = true) => {
    return startOfDay
      ? moment(d).startOf("day").format("YYYY-MM-DD")
      : moment(d).endOf("day").format("YYYY-MM-DD");
  };

  // If no start date is chosen, or if both startDate and endDate are already set, start a new selection:
  if (!startDate || (startDate && endDate)) {
    setStartDate(date);
    setEndDate(null);
    setSelectingEnd(true);
  } else {
    let newStartDate = startDate;
    let newEndDate = date;

    // If the user picks an earlier day than startDate, swap them:
    if (date.isBefore(startDate, "day")) {
      newStartDate = date;
      newEndDate = startDate;
    }

    // If startDate and endDate are the same, extend the end date by one day
    // if (newStartDate.isSame(newEndDate, "day")) {
    //   newEndDate = moment(newEndDate).add(1, "day");
    // }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setSelectingEnd(false);

    // Format the dates for API call
    const formattedStart = formatDate(newStartDate, true);
    const formattedEnd = formatDate(newEndDate, false);

    // Update the date range state
    setDateRangeData({
      startDate: formattedStart,
      endDate: formattedEnd,
    });

    // Fetch updated reports
    await refreshTicketsHistory(
      formattedStart,
      formattedEnd,
      1,
      getShopIdForRefresh(selectedShopRef.current)
    );
  }
};


  useEffect(() => {
    // Load tickets whenever currentPage changes
    // const { startDate, endDate } = dateRangeData;

    const loadBettingShops = async() => {
      const responseShopsList = await axios.get(`${API_URL}/bettingshops`); // Example API URL
      let shopsListRes = (responseShopsList.data || []).reverse();
      // filter shops by user permissions

      const allowedShopIds = localStorage.getItem('sun_bettingShopsList').split(',') || []

      let filteredShops = shopsListRes.concat();
      if (allowedShopIds.length) {
        filteredShops = filteredShops.filter(o => allowedShopIds.includes(o._id));
      }

      setShopsList(filteredShops);
      let shopId = '';
      if (isCashier) {
        shopId = getCashierShopId() || (filteredShops[0] && filteredShops[0]._id) || '';
      } else if (filteredShops.length) {
        shopId = filteredShops[0]._id;
      }
      if (shopId) {
        setSelectedShop(shopId);
      }
      return shopId;
    };

    loadBettingShops().then((shopId)=>{
      // setSelectedShop(shopId);
      // refreshShiftsHistory(startDate, endDate, currentPage, firstShopId);
    });

  }, [getCashierShopId, isCashier]);


  // Helper to convert a picked day to "YYYY-MM-DD" (if that's your backend format)
  function dateToISO(day, startOfDay = true) {
    if (!day) return "";
    const d = startOfDay
      ? moment(day).startOf("day")
      : moment(day).endOf("day");
    // Returns "YYYY-MM-DD"
    return d.format("YYYY-MM-DD");
  }
 

 

  useEffect(() => {
    document.body.classList.add('validate-active');
    if (isCashier) {
      setIsMenuOpen(true);
    }

    return () => {
      document.body.classList.remove('validate-active');
    };
  }, [isCashier]);

  // ✅ Function to check access
  const hasAccess = (path) => user && permissions[user.role]?.includes(path);

  // Common fetch function
  const refreshTicketsHistory = useCallback(async (custStartDate, custEndDate, page = 1, currentSelectedShop) => {
    try {
      let reportsParams = { page, limit };

      if (isFirstLoadRef.current) {
        const today = new Date();
        let firstStartDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        let firstEndDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();

        const formatDate = (d, startOfDay = true) => {
          return startOfDay
            ? moment(d).startOf("day").toISOString()
            : moment(d).endOf("day").toISOString();
        };
      
        // Format the dates for API call
        const formattedStart = formatDate(firstStartDate, true);
        const formattedEnd = formatDate(firstEndDate, false);

        setDateRangeData({
          startDate: formattedStart,
          endDate: formattedEnd,
        });

        // setActiveDate("TODAY");
    
        // const convertToDateOnly = (isoString) =>
        //   isoString ? new Date(isoString).toISOString().split("T")[0] : "";
    
        // firstStartDate = convertToDateOnly(firstStartDate);
        // firstEndDate = convertToDateOnly(firstEndDate);
    
        setStartDate(firstStartDate);
        setEndDate(firstEndDate);

        custStartDate = firstStartDate;
        custEndDate = firstEndDate;

        isFirstLoadRef.current = false;
      }

      // If dateRangeData already has them, use them
      if (dateRangeData.startDate) {
        reportsParams.startDate = dateRangeData.startDate;
      }
      if (dateRangeData.endDate) {
        reportsParams.endDate = dateRangeData.endDate;
      }

      // If function arguments are provided, they override
      if (custStartDate) {
        reportsParams.startDate = custStartDate;
      }
      if (custEndDate) {
        reportsParams.endDate = custEndDate;
      }

      const storedUser = JSON.parse(localStorage.getItem("sun_user"));
      const isAdmin = storedUser && storedUser.role === 'ADMIN';
      // const betShopRest = localStorage.getItem('sun_bettingShopId');
      // if (!isAdmin && betShopRest && betShopRest !== 'undefined' && betShopRest !== '-') {
      //   reportsParams.bettingShopId = betShopRest;
      // }

      const rawShopIds = localStorage.getItem('sun_bettingShopsList') || '';
      let shopIds = rawShopIds ? rawShopIds.split(',') : [];
      if (currentSelectedShop) {
        shopIds = [currentSelectedShop];
      }
console.log('!!!%%%shopIds', currentSelectedShop, shopIds)
      if (shopIds.length) {
        reportsParams.bettingShopIdList = JSON.stringify({ $in : shopIds });
      }


      // Choose the timezone you want the backend to treat as "the day".
      // - Use browser TZ (default) to match how the user picked TODAY/YESTERDAY.
      // - Or hardcode your business TZ like 'Europe/Uzhgorod' if needed.
      const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // const REPORTS_TZ = "Europe/Uzhgorod";
      const REPORTS_TZ = DEFAULT_TZ;

      const convertToDateOnly = (value, timeZone = REPORTS_TZ) => {
        if (!value) return "";

        // If it's already YYYY-MM-DD, keep it as-is
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "";

        // Build YYYY-MM-DD in the requested timezone (not UTC)
        const parts = new Intl.DateTimeFormat("en-CA", {
          timeZone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).formatToParts(d);

        const y = parts.find((p) => p.type === "year")?.value;
        const m = parts.find((p) => p.type === "month")?.value;
        const da = parts.find((p) => p.type === "day")?.value;

        return `${y}-${m}-${da}`;
      };

      const ONE_DAY_MS = 24 * 60 * 60 * 1000;

      if (reportsParams.startDate && reportsParams.endDate) {
        const startMs = Date.parse(reportsParams.startDate);
        const endMs = Date.parse(reportsParams.endDate);

        const startDay = convertToDateOnly(reportsParams.startDate);
        const endDay = convertToDateOnly(reportsParams.endDate);

        // Best: use an explicit flag if you have it:
        // const singleDayPreset =
        //   reportsParams.activeDateSelected === "TODAY" ||
        //   reportsParams.activeDateSelected === "YESTERDAY";

        // Fallback: detect the "single-day preset" by duration (< 24h)
        const singleDayPreset =
          Number.isFinite(startMs) &&
          Number.isFinite(endMs) &&
          endMs - startMs < ONE_DAY_MS;

        reportsParams.startDate = startDay;
        reportsParams.endDate = singleDayPreset ? startDay : endDay;
      } else {
        if (reportsParams.startDate) {
          reportsParams.startDate = convertToDateOnly(reportsParams.startDate);
        }
        if (reportsParams.endDate) {
          reportsParams.endDate = convertToDateOnly(reportsParams.endDate);
        }
      }
  



      const response = await axios.get(`${API_URL}/ticketpages`, {
        params: reportsParams, // Pass params dynamically
      });

      const resData = (response && response.data) || [];
      let formattedData = resData.tickets || [];
      setTotalPages(resData.totalPages || 1);

      // Format date/time
      formattedData = formattedData.map((o) => {
        const date = new Date(o.createdAt);
        const formattedTime = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }).format(date);
        o.createdAtF = formattedTime;
        o.redeem = o.redeemed === true ? 'Yes' : 'No';
        if (o.redeemedAt) {
          o.redeemedAtF = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          }).format(new Date(o.redeemedAt)); 
        } else {
          o.redeemedAtF = 'N/A';
        }
        if (!o.redeemedBy) {
          o.redeemedBy = {name: 'N/A'};
        }
        let jackpotSum = 0;
        if (o.megaJackpotId) {
          jackpotSum += parseInt(o.megaJackpotAmount, 10);
        }
        if (o.miniJackpotId) {
          jackpotSum += parseInt(o.miniJackpotAmount, 10);
        }
        o.jackpotSum = jackpotSum;

        return o;
      });

      setData(formattedData);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }, []);

  // Toggle pages
  const handlePageInput = (e) => {
    setInputPage(e.target.value);
  };

  const goToPage = async (page) => {
    const pageNum = Math.max(1, Math.min(totalPages, page));
    if (pageNum === currentPage) {
      setInputPage(pageNum);
      return;
    }

    setCurrentPage(pageNum);
    setInputPage(pageNum);
    await refreshTicketsHistory(
      dateRangeData.startDate,
      dateRangeData.endDate,
      pageNum,
      getShopIdForRefresh(selectedShopRef.current)
    );
  };

 

  const handleDateRange = useCallback(
    async (range) => {
      const today = new Date();
      let startDate, endDate;
  
      if (range === "CUSTOM") {
        setCalendarVisible((prev) => !prev);
        setActiveDate('CUSTOM');
        return;
      }
  
      let activeDateSelected = '';
  
      switch (range) {
        case "TODAY":
          startDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "TODAY";
          break;
  
        case "YESTERDAY":
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          startDate = new Date(yesterday.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(yesterday.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "YESTERDAY";
          break;
  
        case "LAST_7_DAYS":
          const last7Days = new Date(today);
          last7Days.setDate(today.getDate() - 6);
          startDate = new Date(last7Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_7_DAYS";
          break;
  
        case "LAST_30_DAYS":
          const last30Days = new Date(today);
          last30Days.setDate(today.getDate() - 29);
          startDate = new Date(last30Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_30_DAYS";
          break;
  
        default:
          startDate = "";
          endDate = "";
          break;
      }

      const formatDate = (d, startOfDay = true) => {
        return startOfDay
          ? moment(d).startOf("day").toISOString()
          : moment(d).endOf("day").toISOString();
      };
    
      // Format the dates for API call
      const formattedStart = formatDate(startDate, true);
      const formattedEnd = formatDate(endDate, false);

      // Update the date range state
      setDateRangeData({
        startDate: formattedStart,
        endDate: formattedEnd,
      });

      setCurrentPage(1);
      setInputPage(1);
  
      setActiveDate(activeDateSelected);
  
      const convertToDateOnly = (isoString) =>
        isoString ? new Date(isoString).toISOString().split("T")[0] : "";
  
      // startDate = convertToDateOnly(startDate);
      // endDate = convertToDateOnly(endDate);

      setStartDate(startDate);
      setEndDate(endDate);
  
      await refreshTicketsHistory(
        startDate,
        endDate,
        1,
        getShopIdForRefresh(selectedShopRef.current)
      );
  
      console.log("Date Range Selected:", { startDate, endDate });
    },
    [getShopIdForRefresh, refreshTicketsHistory]
  );

  useEffect(() => {
    handleDateRange("TODAY");
  }, [handleDateRange]);

  const formatStringWithHyphens = (input) => {
    // Ensure the input is a string of 12 characters
    if (typeof input !== 'string' || input.length !== 12) {
      return '-';
    }
    return input.match(/.{1,4}/g).join('-');
  };

  const openPopupWithDetails = (id) => {
    const selectedItem = data.find((item) => item._id === id);
    setActiveItemId(id);
    setPopupData(selectedItem);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    setPopupData(null);
    setActiveItemId(null);
  };

  const backMainMenu = () => {
    navigate('/dashboard');
  };

  const sideBetsMap = {
    'BLACK' : 'BLACK',
    'RED' : 'RED',
    'ODD' : 'ODD',
    'EVEN' : 'EVEN',
    'LOW' : '1-18',
    'HIGH' : '19-36',
    'DOZEN1' : '1-12',
    'DOZEN2' : '13-24',
    'DOZEN3' : '25-36',
    'COLUMN1' : 'Column 1',
    'COLUMN2' : 'Column 2',
    'COLUMN3' : 'Column 3',
    'ZEROSPIEL' : 'Zero Spiel',
    'ORPHELINS' : 'Orphelins',
    'VOISINS' : 'Voisins',
    'SNAKE' : 'Snake',
    'REDSPLIT_9_12' : 'Red Split 9,12',
    'REDSPLIT_16_19' : 'Red Split 16,19',
    'REDSPLIT_18_21' : 'Red Split 18,21',
    'REDSPLIT_27_30' : 'Red Split 27,30',
    'BLACKSPLIT_8_11' : 'Black Split 8,11',
    'BLACKSPLIT_10_11' : 'Black Split 10,11',
    'BLACKSPLIT_10_13' : 'Black Split 10,13',
    'BLACKSPLIT_17_20' : 'Black Split 17,20',
    'BLACKSPLIT_26_29' : 'Black Split 26,29',
    'BLACKSPLIT_28_29' : 'Black Split 28,29',
    'BLACKSPLIT_28_31' : 'Black Split 28,31',
    'ZEROSPIEL_0_3' : 'Zero Spiel 0,3',
    'ZEROSPIEL_12_15' : 'Zero Spiel 12,15',
    'ZEROSPIEL_32_35' : 'Zero Spiel 32,35',
    'ZEROSPIEL_26' : 'Zero Spiel 26',
    'TIERS_5_8' : 'Tiers 5,8',
    'TIERS_10_11' : 'Tiers 10,11',
    'TIERS_13_16' : 'Tiers 13,16',
    'TIERS_23_24' : 'Tiers 23,24',
    'TIERS_27_30' : 'Tiers 27,30',
    'TIERS_33_36' : 'Tiers 33,36',
    'ORPHELINS_6_9' : 'Orphelins 6,9',
    'ORPHELINS_14_17' : 'Orphelins 14,17',
    'ORPHELINS_17_20' : 'Orphelins 17,20',
    'ORPHELINS_31_34' : 'Orphelins 31,34',
    'ORPHELINS_1' : 'Orphelins 1',
    'VOISINS_25_26_28_29' : 'Voisins 25,26,28,29',
    'VOISINS_0_2_3' : 'Voisins 0,2,3',
    'VOISINS_4_7' : 'Voisins 4,7',
    'VOISINS_12_15' : 'Voisins 12,15',
    'VOISINS_18_21' : 'Voisins 18,21',
    'VOISINS_19_22' : 'Voisins 19,22',
    'VOISINS_32_35' : 'Voisins 32,35',
  };

  const normalizeNanoId = (value = '') =>
    String(value).replace(/-/g, '').trim().toLowerCase();
  const normalizedSearchNanoId = normalizeNanoId(searchNanoId);
  const filteredData = normalizedSearchNanoId
    ? data.filter((item) => normalizeNanoId(item?.nanoId).includes(normalizedSearchNanoId))
    : data;

  let betAmountFormatted = popupData?.betAmount
    ? parseFloat(popupData.betAmount).toFixed(2)
    : null;

  let fullPayout = (parseInt(popupData?.payoutAmount || 0) + parseInt(popupData?.megaJackpotAmount || 0) + parseInt(popupData?.miniJackpotAmount || 0));
  let payoutAmountFormatted = popupData?.spinId ? parseFloat(fullPayout).toFixed(2) : 'TBD';

  // let payoutAmountFormatted = popupData?.payoutAmount
  //   ? parseFloat(popupData.payoutAmount).toFixed(2)
  //   : null;

  const drawNumber = popupData?.spinNumber; // popupData?.spinId?.prng || '';

  // Example PDF generator (unchanged logic)
  const generatePDF = (type) => {
    const popupDataPdf = popupData;
    if (!popupDataPdf) {
      return;
    }
    const rawTicketId = popupDataPdf.nanoId;
    const ticketId = formatStringWithHyphens(rawTicketId);
    // const hexDTicketId = this.hexToDecimal(rawTicketId);
    const spinNumber = popupDataPdf.spinNumber || '';
  
    const DAY_MINS = 60 * 24;
    const voidAfter = (parseInt(popupDataPdf.voidAfter) / DAY_MINS).toString();
    const validationCode = popupDataPdf.validationCode;

    // let tableRowsLenght = tableRows.length * 0.293;


    let tableRows = [];

    if (type === 'receipt') {
      tableRows = (
        popupDataPdf?.bets ? Object.entries(popupDataPdf.bets) : []
      )
        .filter(([key, value]) => value !== undefined) // Include only placed bets
        .map(([key, value]) => {
          let formKey;
          if (sideBetsMap[key]) {
            formKey = sideBetsMap[key];
          } else if (betmap[key]) {
            formKey = betmap[key].numbers?.join(',');
          } else {
            formKey = key;
          }
          const payout = popupDataPdf.payouts?.[key] !== undefined
            ? parseFloat(popupDataPdf.payouts[key]).toFixed()
            : null; // Include payout if available
          return [formKey, Math.round(value).toFixed(), payout];
        });
    } else if (type === 'ticket') {
      tableRows = (
        popupDataPdf?.bets ? Object.entries(popupDataPdf.bets) : []
      )
        .filter(([key, value]) => value !== undefined) // Include only placed bets
        .map(([key, value]) => {
          let formKey;
          if (sideBetsMap[key]) {
            formKey = sideBetsMap[key];
          } else if (betmap[key]) {
            formKey = betmap[key].numbers?.join(',');
          } else {
            formKey = key;
          }
          const potentialPayout = popupDataPdf.potentialPayouts?.[key] !== undefined
            ? parseFloat(popupDataPdf.potentialPayouts[key]).toFixed()
            : null; // Include payout if available
          return [formKey, Math.round(value).toFixed(), potentialPayout];
        });
    }

    if(popupData.megaJackpotId) {
      tableRows.unshift(['MEGA', '-', popupData.megaJackpotAmount])
      popupData.payoutAmount = parseInt(popupData.payoutAmount) || 0;
      popupData.payoutAmount += parseInt(popupData.megaJackpotAmount, 10);
    }

    if(popupData.miniJackpotId) {
      tableRows.unshift(['MINI', '-', popupData.miniJackpotAmount])
      popupData.payoutAmount = parseInt(popupData.payoutAmount) || 0;
      popupData.payoutAmount += parseInt(popupData.miniJackpotAmount, 10);
    }

    let tableRowsLength = tableRows.length * 0.293;


    let heightTable = 0;
    let height = 6.29; // Default height for the document
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'in',
      format: [3.12, tableRowsLength + 5.8] // Initial height, will recalculate later
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();


    // Set font and size
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
  
    // Text to center
    const text = "ROULETTE";
     // Get page width and text width
    const textWidth = doc.getTextWidth(text);

    // Calculate the x position to center the text
    const x = (pageWidth - textWidth) / 2;

    // Add text
    doc.text(text, x, 0.3);
    const text1 = popupDataPdf.bettingShopId?.name || '';
    const textWidth1 = doc.getTextWidth(text1);
    const x1 = (pageWidth - textWidth1) / 2;
  
    doc.setFontSize(12);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text1, x1, 0.6);  
  
    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 0.9);  
  
    const text2 = "TICKET (COPY)";
    const textWidth2 = doc.getTextWidth(text2);
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text2, 0.25, 1.1);  
  
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(`${ticketId}`, textWidth2 + 0.05, 1.1);  
  
    const text3 = "DRAW";
    const textWidth3 = doc.getTextWidth(text3);
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text3, 0.25, 1.4);  
   
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(`#${spinNumber}`, 0.3 + textWidth3, 1.4); 


 
    const date = popupDataPdf.createdAtF;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text(date, 1.3, 1.4); 
  
  
    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 1.75);  
  
  
  
    doc.setFontSize(12);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("Bet", 0.25, 1.9);   
  
    // const rightMargin = 0.25;
    // const pageWidth2 = doc.internal.pageSize.width;
  
    // const textX = pageWidth2 - rightMargin;
   
    doc.setFontSize(9);
    if (type === 'ticket') {    
      // doc.text("Amount", textX, 1.9, { align: 'right' });
      doc.text("Amount", 2.3, 1.9, { align: 'right' });
      doc.text("Potential", 2.9, 1.9, { align: 'right' });
    }

    if (type === 'receipt') {
      doc.text("Amount", 2.3, 1.9, { align: 'right' });
      doc.text("Payout", 2.8, 1.9, { align: 'right' });
    }
  


 
    const columnStyles = {
      0: { halign: 'left', fillColor: [255, 255, 255] }, 
    };



    columnStyles[0] = { halign: 'left', cellWidth: 1.7, fillColor: [255, 255, 255] };
    columnStyles[1] = { halign: 'right',  fillColor: [255, 255, 255] };
    columnStyles[2] = { halign: 'right',  fillColor: [255, 255, 255] };

    // if (type === 'receipt') {
    //   columnStyles[0] = { halign: 'left', cellWidth: 1.7, fillColor: [255, 255, 255] };
    //   columnStyles[1] = { halign: 'right',  fillColor: [255, 255, 255] };
    //   columnStyles[2] = { halign: 'right',  fillColor: [255, 255, 255] };
    // }

    // if (type === 'ticket') {
    //   columnStyles[1] = { halign: 'right', fillColor: [255, 255, 255] };
    // }


    doc.autoTable({ 
      body: tableRows,
      startY: 2,
      tableWidth: 2.7,
      margin: { left: 0.2 },
      styles: {
        fontSize: 9,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: 'bold', 
      },
      columnStyles, 
      didDrawPage: function (data) {

        heightTable = data.cursor.y - 1.9; 
        console.log("Table Height:", heightTable);
      },
    });

    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.2);  
  
    doc.setFontSize(10);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("TOTAL", 0.25, heightTable + 2.4); 
  


    let payoutAmountFormatted = null;
    if (popupDataPdf?.payoutAmount) {
      payoutAmountFormatted = Math.round(popupDataPdf.payoutAmount).toFixed();
    }

    let potentialPayoutAmountFormatted = null;
    if (popupDataPdf?.potentialPayoutAmount) {
      potentialPayoutAmountFormatted = Math.round(popupDataPdf.potentialPayoutAmount).toFixed();
    }

    // Define the right margin
    // Adjust this value as needed
  
    // Get page width

    // if (type === 'ticket') {
    //   const totalBet = `${parseInt(popupDataPdf.betAmount).toFixed()}`;
  
    //   // Set the font properties
    //   doc.setFontSize(12);
    //   doc.setFont('helvetica', 'bold');
    //   doc.setTextColor(0, 0, 0);
    
    //   // Add text, aligned to the right
    //   doc.text(totalBet, textX, heightTable + 2.4, { align: 'right' });
    // }

    if (type === 'ticket') {
      const totalBet = `${parseInt(popupDataPdf.betAmount).toFixed()}`;
      const totalPotentialPayout = `${potentialPayoutAmountFormatted}`;
  
      // Set the font properties
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
    
      // Add text, aligned to the right
      doc.text(totalBet, 2.4, heightTable + 2.4, { align: 'right' });
      doc.text(totalPotentialPayout, 2.9, heightTable + 2.4, { align: 'right' });
    } 

    if (type === 'receipt') {
      const totalBet = `${parseInt(popupDataPdf.betAmount).toFixed()}`;
      const totalPayouts = `${payoutAmountFormatted}`;
  
      // Set the font properties
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
    
      // Add text, aligned to the right
      doc.text(totalBet, 2.4, heightTable + 2.4, { align: 'right' });
      doc.text(totalPayouts, 2.9, heightTable + 2.4, { align: 'right' });
    }
  
    // const totalBet = `$${this.state.betsTotal.toFixed(2)}`;
  
   
    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.7);  
  
    const canvas = document.createElement('canvas');
    bwipjs.toCanvas(canvas, {
      bcid: 'code128',       // Barcode type
      text: rawTicketId,     // Text to encode
      scale: 5,              // Scale factor
      rotate: 'N',
      height: 1,            // Height of the barcode
      width: 3,
      includetext: false,     // Include text below the barcode
    });

    const barcodeImage = canvas.toDataURL();

  const BARCODE_OFFSET = 2.9;

  // Add the rotated barcode image to the PDF
  doc.addImage(barcodeImage, 'PNG', 0.05, heightTable + BARCODE_OFFSET, 3, 1);


  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');


  const textBefore = "Validation Code ";
  const number = validationCode;
  const textAfter = "";


  // Calculate the widths of the texts
  const textBeforeWidth = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth = doc.getTextWidth(number);
  const totalTextWidth = textBeforeWidth + numberWidth + doc.getTextWidth(textAfter);

  const xStart = (pageWidth - totalTextWidth) / 2; // Center the text on the page

  const BOTTOM_TEXT_OFFSET = 4.2;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore, xStart, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number, xStart + textBeforeWidth, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter, xStart + textBeforeWidth + numberWidth, heightTable + BOTTOM_TEXT_OFFSET);


  const textBefore2 = "Ticket Void after ";
  const number2 = voidAfter;
  const textAfter2 = "days";

  const textBeforeWidth2 = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth2 = doc.getTextWidth(number2);
  const totalTextWidth2 = textBeforeWidth2 + numberWidth2 + doc.getTextWidth(textAfter);

  

  const xStart2 = xStart - 0.2;
  const BOTTOM_TEXT_OFFSET2 = 4.4;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore2, xStart2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number2, xStart2 + totalTextWidth2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter2, xStart2 + totalTextWidth2 + numberWidth, heightTable + BOTTOM_TEXT_OFFSET2);





  doc.setFontSize(12);  
  doc.setFont('helvetica', 'bold'); 
  const text4 = "THANK YOU";
  const textWidth4 = doc.getTextWidth(text4);
  const x4 = (pageWidth - textWidth4) / 2;
  doc.setTextColor(0, 0, 0);
  const THANK_TEXT_OFFSET = 7.62;
  doc.text(text4, x4, heightTable + THANK_TEXT_OFFSET);



  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 5.4);  


  if (type === 'ticket' && popupDataPdf.isVoid) {
    doc.saveGraphicsState();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(48);
    doc.setTextColor(200, 0, 0); // very light gray

    const label = "VOIDED";

    // Center of the page
    const cy = pageHeight / 2 + 1;

    // Convert font size (points) -> your units (inches here)
    const fontSizePt = doc.getFontSize();               // 48 (pt)
    const fontSizeIn = fontSizePt / doc.internal.scaleFactor; // scaleFactor=72 for "in"

    // Shift right by half the rotated text “height” so it looks horizontally centered
    const cx = (pageWidth / 2) + (fontSizeIn / 2) + 1.1;

    doc.text(label, cx, cy, {
      angle: 90,
      align: "center",
      baseline: "middle", // helps if your jsPDF version supports it
    });

    doc.restoreGraphicsState();    
  }


  // doc.save(`Ticket.pdf`);
  // return;
  // const pdfBlob = doc.output("blob");
  // const pdfURL = URL.createObjectURL(pdfBlob);
  // const pdfViewer = document.getElementById("pdfViewer");
  // pdfViewer.innerHTML = `<iframe src="${pdfURL}" width="100%" height="500px"></iframe>`;


  // Automatically open the print dialog
  doc.autoPrint();

  // Open the PDF directly in a new browser tab
  const pdfBlob = doc.output("blob");
  const blobURL = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "0";
  iframe.style.left = "0";
  iframe.style.width = "1px";
  iframe.style.height = "1px";
  iframe.style.border = "none";
  iframe.src = blobURL;

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print(); // Trigger print directly
  };

  document.body.appendChild(iframe);
  // Clean up the iframe after printing
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);

  const userId = localStorage.getItem("sun_userId");
  axios.post(`${API_URL}/logaction`, {
    action: `${type}_ticket`,
    user: userId,
  }).then(()=>{});

  }

  const handleExport = async() => {


    let reportsParams = { page: 1, limit: 100000 };

    if (dateRangeData.startDate) {
      reportsParams.startDate = dateRangeData.startDate;
    }

    if (dateRangeData.endDate) {
      reportsParams.endDate = dateRangeData.endDate;
    }


    // Choose the timezone you want the backend to treat as "the day".
    // - Use browser TZ (default) to match how the user picked TODAY/YESTERDAY.
    // - Or hardcode your business TZ like 'Europe/Uzhgorod' if needed.
    const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const REPORTS_TZ = "Europe/Uzhgorod";
    const REPORTS_TZ = DEFAULT_TZ;

    const convertToDateOnly = (value, timeZone = REPORTS_TZ) => {
      if (!value) return "";

      // If it's already YYYY-MM-DD, keep it as-is
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";

      // Build YYYY-MM-DD in the requested timezone (not UTC)
      const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).formatToParts(d);

      const y = parts.find((p) => p.type === "year")?.value;
      const m = parts.find((p) => p.type === "month")?.value;
      const da = parts.find((p) => p.type === "day")?.value;

      return `${y}-${m}-${da}`;
    };

    const ONE_DAY_MS = 24 * 60 * 60 * 1000;

    if (reportsParams.startDate && reportsParams.endDate) {
      const startMs = Date.parse(reportsParams.startDate);
      const endMs = Date.parse(reportsParams.endDate);

      const startDay = convertToDateOnly(reportsParams.startDate);
      const endDay = convertToDateOnly(reportsParams.endDate);

      // Best: use an explicit flag if you have it:
      // const singleDayPreset =
      //   reportsParams.activeDateSelected === "TODAY" ||
      //   reportsParams.activeDateSelected === "YESTERDAY";

      // Fallback: detect the "single-day preset" by duration (< 24h)
      const singleDayPreset =
        Number.isFinite(startMs) &&
        Number.isFinite(endMs) &&
        endMs - startMs < ONE_DAY_MS;

      reportsParams.startDate = startDay;
      reportsParams.endDate = singleDayPreset ? startDay : endDay;
    } else {
      if (reportsParams.startDate) {
        reportsParams.startDate = convertToDateOnly(reportsParams.startDate);
      }
      if (reportsParams.endDate) {
        reportsParams.endDate = convertToDateOnly(reportsParams.endDate);
      }
    }


    let shopIds = localStorage.getItem('sun_bettingShopsList').split(',')
console.log('EXPORT selectedShop', selectedShop);    
    if (selectedShop) {
      shopIds = [selectedShop];
    }
    if (shopIds.length) {
      reportsParams.bettingShopIdList = JSON.stringify({ $in : shopIds });
    }

    const response = await axios.get(`${API_URL}/ticketpages`, {
      params: reportsParams, // Pass params dynamically
    });


    const resData = (response && response.data) || [];
    let formattedData = resData.tickets || [];

    // Format date/time
    formattedData = formattedData.map((o) => {
      const date = new Date(o.createdAt);
      const formattedTime = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: '2-digit',
        // year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      }).format(date);
      o.createdAt = formattedTime;

      if (o.redeemedAt) {
        o.redeemedAt = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          // year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }).format(new Date(o.redeemedAt)); 
      } else {
        o.redeemedAt = 'N/A';
      }
      o.redeem = o.redeemed === true ? 'Yes' : 'No';

      let jackpotSum = 0;
      if (o.megaJackpotId) {
        jackpotSum += parseInt(o.megaJackpotAmount, 10);
      }
      if (o.miniJackpotId) {
        jackpotSum += parseInt(o.miniJackpotAmount, 10);
        console.log('o.miniJackpotId', o.miniJackpotId, o.miniJackpotAmount, jackpotSum);
      }
      o.jackpotSum = jackpotSum;

      return o;
    });

    const dataToExport = formattedData.map(item => ({
      'TICKET ID': item.nanoId || '--',
      'BET AMOUNT': item.betAmount || '--',
      'PAYOUT': item.payoutAmount,
      'JACKPOT': item.jackpotSum || 0,
      'DRAW': item.spinId?.prng,
      'SPIN NUMBER': item.spinId?.spinNumber,
      'REDEEM': item.redeem || 'N/A',
      'REDEEMED BY': item.redeemedBy?.name || 'N/A',
      'REDEEMED AT': item.redeemedAt || 'N/A',
      'CREATED BY': item.agentId?.name,
      'CREATED AT': item.createdAt,
    }));

    // Calculate the total item
    const totalTickets = formattedData.length;
    const redeemedCount = formattedData.filter(item => item.redeem === "Yes").length;
    const totalBet = formattedData.reduce((sum, item) => sum + (Number(item.betAmount) || 0), 0);
    let totalRedeemed = formattedData.reduce((sum, item) => item.redeem === "Yes" ? sum + (Number(item.payoutAmount) || 0) : sum, 0);
    const totalJackpot = formattedData.reduce((sum, item) => sum + (Number(item.jackpotSum) || 0), 0);
    // calculate redeemed total jackpot and add it to totalRedeemed
    const totalRedeemedJackpot = formattedData.reduce((sum, item) => item.redeem === "Yes" ? sum + (Number(item.jackpotSum) || 0) : sum, 0);
    totalRedeemed = totalRedeemed + totalRedeemedJackpot;

    const totalItem = {
      'TICKET ID': totalTickets,
      'BET AMOUNT': totalBet,
      'PAYOUT': totalRedeemed,
      'JACKPOT': totalJackpot,
      'DRAW': '-',
      'SPIN NUMBER': '-',
      'REDEEM': redeemedCount,
      'REDEEMED BY': '-',
      'REDEEMED AT': '-',
      'CREATED BY': '-',
      'CREATED AT': '-',
    };

    const totalLbl = {
      'TICKET ID': `Tickets Sold`,
      'BET AMOUNT': `Total Bet`,
      'PAYOUT': `Total RDM`,
      'DRAW': '-',
      'SPIN NUMBER': '-',
      'REDEEM': `Tickets RDM`,
      'REDEEMED BY': '-',
      'REDEEMED AT': '-',
      'CREATED BY': '-',
      'CREATED AT': '-',
    };

    dataToExport.push(totalItem);
    dataToExport.push(totalLbl);


    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Tickets');

    const { startDate, endDate } = dateRangeData;
    const formattedStart = moment(startDate).format("DDMMMYYYY");
    const formattedEnd = moment(endDate).format("DDMMMYYYY");

    const fileName =
      formattedStart === formattedEnd
        ? formattedStart
        : `${formattedStart}_${formattedEnd}`;

    XLSX.writeFile(workbook, `TicketsHistory_${fileName}.xlsx`);
  };



  return (
    <>
      <div className="dashbord-wr"> 
      
          {/* Role Selection Buttons Debug */}

        <div className={`admin-page-menu ${isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
        {/* Toggle button */}
        {/* <div className="admin-page-menu__toggle" onClick={toggleMenu}>
          <div className="admin-page-menu__toggle-icon">
            <img src={isMenuOpen ? iconClose : iconOk} alt={isMenuOpen ? "Close" : "Open"} />
          </div>
        </div> */}
        
        {/* Menu items - only show when menu is open */}
        {isMenuOpen && (
          <>
            <div className="admin-page-menu__item" onClick={() => navigate('/dashboard')}>
              <div className="admin-page-menu__item-icon">
                <img src={homeIcon} alt="Home" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Home</span>
              </div>
            </div>
            <div className="admin-page-menu__item" onClick={() => navigate('/admin')}>
              <div className="admin-page-menu__item-icon">
                <img src={createIcon} alt="Create" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Create</span>
              </div>
            </div>
            <div className="admin-page-menu__item" onClick={() => navigate('/validate')}>
              <div className="admin-page-menu__item-icon">
                <img src={validateIcon} alt="Validate" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Validate</span>
              </div>
            </div>
            <div className="admin-page-menu__item" onClick={() => navigate('/tickethistory')}>
              <div className="admin-page-menu__item-icon">
                <img src={historyIcon} alt="History" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>History</span>
              </div>
            </div>
            <div className="admin-page-menu__item" onClick={() => navigate('/shift-management')}>
              <div className="admin-page-menu__item-icon">
                <img src={shiftIcon} alt="Shift" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Shift</span>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="validate validate-history">
        <div className="validate-top-wrap">
          <div className="validate_top-left">
            <div className="spin-border dashbord-border">
              <div className="spin-light spin-light-top">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
              <div className="spin-number">
                <div className="spin-number__text">
                  <span className="spin-number__text-big">TICKETS HISTORY</span>
                </div>
              </div>
              <div className="spin-light spin-light-bottom">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="validate_top-middel">
            <div className="date-range-wrap-box">
          {!startDate ? (
            // If no startDate at all:
            "No date selected"
          ) : !endDate || moment(startDate).isSame(endDate, "day") ? (
            // If endDate is null OR both dates are the same day:
            (() => {
              const date = moment(startDate);

              // If it's exactly "today":
              if (moment().isSame(date, "day")) {
                return date.format("MMM DD, YYYY"); // e.g. "Feb 21, 2025"
              }
              // If it's exactly "yesterday":
              if (moment().subtract(1, "days").isSame(date, "day")) {
                return date.format("MMM DD, YYYY");
              }
              // Otherwise, just return the single date
              return date.format("MMM DD, YYYY");
            })()
          ) : (
            // If we have a valid range (two different days):
            (() => {
              const start = moment(startDate);
              const end = moment(endDate);
              const rangeDays = end.diff(start, "days");

              // If the range is exactly 1 day, just show the end date
              if (rangeDays === 1) {
                return start.format("MMM DD, YYYY");
              }

              // If the end date is "today" and range > 1
              if (moment().isSame(end, "day") && rangeDays > 1) {
                return (
                  <>
                    {start.format("MMM DD, YYYY")}
                    {" - "}
                    {end.format("MMM DD, YYYY")}
                  </>
                );
              }

              // If the end date is "today" and range <= 2
              if (moment().isSame(end, "day") && rangeDays <= 2) {
                return "Today";
              }

              // If the end date is "yesterday" and range <= 2
              if (moment().subtract(1, "days").isSame(end, "day") && rangeDays <= 2) {
                return "Yesterday";
              }

              // Default: "start - end" format
              if (activeDate === 'LAST_7_DAYS' || activeDate === 'LAST_30_DAYS') {
                return (
                  <>
                    {start.format("MMM DD, YYYY")}
                    {" - "}
                    {end.subtract(1, "days").format("MMM DD, YYYY")}
                  </>
                );
              }
              return (
                <>
                  {start.format("MMM DD, YYYY")}
                  {" - "}
                  {end.format("MMM DD, YYYY")}
                </>
              );
            })()
          )}

            <div className="search-box-wrap">
              <input
                type="text"
                className="betting-form__input betting-form__input-width-sl"
                placeholder="Search by Ticket ID"
                value={searchNanoId}
                onChange={handleNanoIdSearchChange}
              />
            </div>

          </div>

          </div>

          <div className="validate_top-right">
            <button className="return-menu btn-yellow" onClick={backMainMenu}>
              RETURN TO MAIN MENU
            </button>
          </div>
        </div>

        <div className="validate-bottom-wrap">
          <div className="report_filter-date report_filter-date-valid">

            {!isCashier && (
              <div className="report_filter-date-sl">
                <select
                  className="betting-form__input betting-form__input-width-sl"
                  name="role"
                  value={selectedShop}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Select Shop
                  </option>
                  {shopsList.map((shop) => (
                    <option key={shop._id} value={shop._id}>
                      {shop.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            
            <div
              className={`report_filter-date-item ${activeDate==='TODAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("TODAY")}
            >
              TODAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='YESTERDAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("YESTERDAY")}
            >
              YESTERDAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_7_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_7_DAYS")}
            >
              LAST 7 DAYS
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_30_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_30_DAYS")}
            >
              LAST 30 DAYS
            </div>
            <div
              className={`report_filter-date-item-custom report_filter-date-item ${activeDate==='CUSTOM' ? "date-active" : ""}`}
              onClick={() => handleDateRange("CUSTOM")}
            >
              <span className="report_filter-date-custom-span">CUSTOM</span>
            </div>
            <div
              className={'report_filter-date-item'}
              onClick={() => handleExport()}
            >
              EXPORT XLS
            </div>

            {isCalendarVisible && (
              <div className="calendar-container">
                <Datetime
                  onChange={handleDateChange}
                  open={true}
                  input={false}
                  timeFormat={false}
                  closeOnSelect={false}
                  ref={calendarRef}
                  isValidDate={(current) => {
                    // Allow all dates when selecting start
                    if (!startDate || !selectingEnd) return true;
                  
                    // When selecting end, it must be same or after start
                    return moment(current).isSameOrAfter(startDate, "day");
                  }}
                  renderDay={(props, currentDate, selectedDate) => {
            
                    let className = props.className;
                    if (startDate && endDate) {
                      if (currentDate.isBetween(startDate, endDate, "day", "[]")) {
                        className += " rdt-day-in-range";
                      }
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                      if (currentDate.isSame(endDate, "day")) {
                        className += " rdt-day-end";
                      }
                    } else if (startDate && !endDate) {
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                    }
                    return (
                      <td {...props} className={className}>
                        {currentDate.date()}
                      </td>
                    );
                  }}

                
                  renderView={(mode, renderDefault, viewProps) => {
   
                    const defaultCalendar = renderDefault();
                    return (
                      <div>
                        {defaultCalendar}
             
                        <div style={{ textAlign: "center", marginTop: 8 }}>
                          <button
                            className="btn-ok"
                            onClick={() => {
          
                              setCalendarVisible(false);
                         
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            )}
            
          </div>

          <div className="validate-bot-wrap">
            <div className={`validate-left ${isPopupVisible ? "active-class" : ""}`}>
              <div className="table-maket">
                <table>
                  <thead>
                    <tr>
                      <th>TICKET ID</th>
                      <th>SHOP</th>
                      <th>BET AMOUNT</th>
                      <th>PAYOUT</th>
                      <th>JACKPOT</th>
                      <th>DRAW</th>
                      <th>SPIN NUMBER</th>
                      <th>REDEEM</th>
                      <th>REDEEMED BY</th>
                      <th>REDEEMED AT</th>
                      <th>VOIDED</th>
                      <th>CREATED BY</th>
                      <th>CREATED AT</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item) => (
                      <tr key={item._id}>
                        <td className="ticket-id-format table-maket-col_yellow">
                          {formatStringWithHyphens(item.nanoId)}
                        </td>
                        <td>{item.bettingShopId?.name}</td>
                        <td>{item.betAmount}</td>
                        <td>{item.payoutAmount}</td>
                        <td>{item.jackpotSum}</td>
                        <td>{item.spinId?.prng}</td>
                        <td>{item?.spinNumber}</td>
                        <td>{item.redeem}</td>
                        <td>{item.redeemedBy?.name}</td>
                        <td>{item.redeemedAtF}</td>
                        <td>{item.isVoid ? 'Yes' : 'No'}</td>
                        <td>{item.agentId?.name}</td>
                        <td>{item.createdAtF}</td>
                        <td>
                          {/* <button disabled={item.spinId === null}></button> */}
                          <button
                            className={`table-maket__btn ${
                              (activeItemId === item._id)
                                ? 'table-maket__btn-active'
                                : ''
                            }`}
                            onClick={() => openPopupWithDetails(item._id)}
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="pagination">
                {/* Previous Button */}
                <button
                  className="prev"
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <span>&laquo;</span>
                </button>

                {/* First Page */}
                <button
                  className={`page ${currentPage === 1 ? "active" : ""}`}
                  onClick={() => goToPage(1)}
                >
                  1
                </button>

                {/* Dots Before Middle Pages */}
                {currentPage > 4 && totalPages > 6 && <span className="dots">...</span>}

                {/* Dynamic Middle Pages */}
                {Array.from({ length: 5 }, (_, index) => {
                  let pageNumber = Math.max(2, currentPage - 2) + index;
                  if (pageNumber >= totalPages) return null;
                  return (
                    <button
                      key={pageNumber}
                      className={`page ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                      onClick={() => goToPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  );
                })}

                {/* Dots Before Last Page */}
                {currentPage < totalPages - 3 && totalPages > 6 && (
                  <span className="dots">...</span>
                )}

                {/* Last Page */}
                {totalPages > 1 && (
                  <button
                    className={`page ${currentPage === totalPages ? "active" : ""}`}
                    onClick={() => goToPage(totalPages)}
                  >
                    {totalPages}
                  </button>
                )}

                {/* Page Input */}
                <input
                  type="number"
                  className="page-input"
                  value={inputPage}
                  onChange={handlePageInput}
                  onKeyDown={(e) =>
                    e.key === "Enter" && goToPage(Number(inputPage))
                  }
                  min="1"
                  max={totalPages}
                />

                {/* Next Button */}
                <button
                  className="next"
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <span>&raquo;</span>
                </button>
              </div>
            </div>

            {isPopupVisible && popupData && (
              <div className={`validate-right ${isPopupVisible ? "popup-active" : ""}`}>
                <div className="validate__table">
                  <div className="spin-wrap-validate">
                    <div className="spin-border mini-spin">
                      <div className="spin-light spin-light-top">
                        <div className="spin-light-container">
                          {Array.from({ length: 15 }).map((_, index) => (
                            <div
                              className="spin-light-item"
                              style={{ animationDelay: `${index * 0.2}s` }}
                              key={index}
                            ></div>
                          ))}
                        </div>
                      </div>
                      <div className="spin-number">
                        <div className="spin-number__text">
                          <span className="spin-number__text-big">TICKET DETAILS</span>
                        </div>
                      </div>
                      <div className="spin-light spin-light-bottom">
                        <div className="spin-light-container">
                          {Array.from({ length: 15 }).map((_, index) => (
                            <div
                              className="spin-light-item"
                              style={{ animationDelay: `${index * 0.2}s` }}
                              key={index}
                            ></div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="ticket-table-validate">
                      <div className="ticket-table__title">
                        <div className="ticket-table__title-info">TICKET ID:</div>
                        <div className="ticket-table__title-id">
                          {formatStringWithHyphens(popupData.nanoId)}
                        </div>
                      </div>
                      {popupData.isVoid && <div className="ticket-table__block">
                        <div className="ticket-table__draw ticket-table__void-lbl">
                          VOIDED  
                        </div>
                      </div>}
                      <div className="ticket-table__block">
                        <div className="ticket-table__draw">
                          DRAW<span> : </span>
                          {drawNumber}
                        </div>
                        <div className="ticket-table__date">{popupData.createdAtF}</div>
                      </div>

                      <div className="ticket-table__table">
                        <div className="ticket-table__table-top">
                          <div className="ticket-table__table-top__item">BET TYPE</div>
                          <div className="ticket-table__table-top__item">AMOUNT</div>
                          <div className="ticket-table__table-top__item">PAYOUT</div>
                        </div>
                        <div className="ticket-table__table-middle">
                        {popupData.megaJackpotId && (
                            <div className="ticket-table__table-middle-row">
                              <div className="ticket-table__table-middle__col"
                                style={{ width: "33%", paddingRight: "5px" }}
                              >MEGA</div>
                              <div className="ticket-table__table-middle__col">-</div>
                              <div className="ticket-table__table-middle__col">{parseInt(popupData.megaJackpotAmount).toFixed()}</div>
                            </div>
                          )}

                        {popupData.miniJackpotId && (
                            <div className="ticket-table__table-middle-row">
                              <div className="ticket-table__table-middle__col"
                                style={{ width: "33%", paddingRight: "5px" }}
                              >MINI</div>
                              <div className="ticket-table__table-middle__col">-</div>
                              <div className="ticket-table__table-middle__col">{parseInt(popupData.miniJackpotAmount).toFixed()}</div>
                            </div>
                          )}

                          {popupData.bets &&
                            Object.entries(popupData.bets).map(([key, value]) => {
                              let formKey;
                              if (sideBetsMap[key]) {
                                formKey = sideBetsMap[key];
                              } else if (betmap[key]) {
                                // For example, betmap.json might have "numbers" etc.
                                formKey = betmap[key].numbers?.join(',') || key;
                              } else {
                                formKey = key;
                              }
                              return (
                                <div
                                  key={key}
                                  className="ticket-table__table-middle-row"
                                >
                                  <div className="ticket-table__table-middle__col">
                                    {formKey}
                                  </div>
                                  <div className="ticket-table__table-middle__col">
                                    {value ? parseInt(value).toFixed(2) : '-'} 
                                  </div>
                                  <div className="ticket-table__table-middle__col">
                                    {(popupData.spinId ? (popupData?.payouts && parseInt(popupData?.payouts?.[key]).toFixed(2)) : 'TBD')}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="ticket-table__table-bottom">
                          <div className="ticket-table__table-bottom__item">TOTAL</div>
                          <div className="ticket-table__table-bottom__item">
                            {betAmountFormatted}
                          </div>
                          <div className="ticket-table__table-bottom__item">
                            {payoutAmountFormatted}
                          </div>
                        </div>
                      </div>

                      <div className="ticket-table__ticket-date">TICKET VOID AFTER 5 DAYS</div>
                      <div className="ticket-table__ticket-btn">
                        {/* Example if you want to print a "receipt" version:
                           <button className="btn-blue btn-ticket-table" onClick={() => generatePDF('receipt')}>
                             REDEEM TICKET
                           </button>
                        */}
                        {hasAccess("/printticket") && <button className="btn-blue btn-ticket-table" onClick={() => generatePDF('ticket')}>
                          REPRINT TICKET
                          </button>}

                        {hasAccess("/printreceipt") && !popupData.isVoid && <button className="btn-blue btn-ticket-table" onClick={() => generatePDF('receipt')}>
                          REPRINT RECEIPT
                          </button>}

                        <button className="btn-blue btn-ticket-table" onClick={closePopup}>
                          CLOSE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div id="pdfViewer"></div>

      {/* Hidden table for reference if you need it */}
      <div className="ticket-table" style={{ display: "none" }}>
        <h3 className="ticket-table__title">Tickets history</h3>
        <table>
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Bet Amount</th>
              <th>Payout</th>
              <th>Draw</th>
              <th>Redeem</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => (
              <tr key={item._id}>
                <td className="ticket-id-format">{formatStringWithHyphens(item.nanoId)}</td>
                <td>{item.betAmount}</td>
                <td>{item.payoutAmount}</td>
                <td>{item.spinId?.prng}</td>
                <td>{item.redeem}</td>
                <td>{item.createdAtF}</td>
                <td>
                  <button disabled={item.spinId === null}
                    className="wrap-validate_item"
                    onClick={() => openPopupWithDetails(item._id)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>      
      </div>
    </>
  );
}

export default Tickethistory;
